<card name="Таблицы">
  <div card content>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Type</th>
        <th>Column heading</th>
        <th>Column content</th>
        <th>Column heading numbers</th>
        <th>
          <div class="d-flex">
            Column heading with icons
            <i class="fas text-primary fs-12 ml-1 mt-1 fa-sort"></i>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Default</td>
        <td>Column heading</td>
        <td>Column content</td>
        <td class="text-right">123</td>
        <td>
              <span class="badge badge-circle">
                <i class="fas fa-vial"></i>
              </span>
          Column content with icons
        </td>
      </tr>
      <tr class="table-row-active">
        <td>Active</td>
        <td>Column heading</td>
        <td>Column content</td>
        <td class="text-right">123</td>
        <td>
              <span class="badge badge-circle">
                <i class="fas fa-vial"></i>
              </span>
          Column content with icons
        </td>
      </tr>
      <tr>
        <td>Hover</td>
        <td>Column heading</td>
        <td>Column content</td>
        <td class="text-right">123</td>
        <td>
              <span class="badge badge-circle">
                <i class="fas fa-vial"></i>
              </span>
          Column content with icons
        </td>
      </tr>
      </tbody>
    </table>

    <table class="table table-hover table-bordered mt-5">
      <thead>
      <tr>
        <th>Type</th>
        <th>Column heading</th>
        <th>Column content</th>
        <th>Column heading numbers</th>
        <th>
          <div class="d-flex">
            Column heading with icons
            <i class="fas text-primary fs-12 ml-1 mt-1 fa-sort"></i>
          </div>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Default</td>
        <td>Column heading</td>
        <td>Column content</td>
        <td class="text-right">123</td>
        <td>
              <span class="badge badge-circle">
                <i class="fas fa-vial"></i>
              </span>
          Column content with icons
        </td>
      </tr>
      <tr class="table-row-active">
        <td>Active</td>
        <td>Column heading</td>
        <td>Column content</td>
        <td class="text-right">123</td>
        <td>
              <span class="badge badge-circle">
                <i class="fas fa-vial"></i>
              </span>
          Column content with icons
        </td>
      </tr>
      <tr>
        <td>Hover</td>
        <td>Column heading</td>
        <td>Column content</td>
        <td class="text-right">123</td>
        <td>
              <span class="badge badge-circle">
                <i class="fas fa-vial"></i>
              </span>
          Column content with icons
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</card>
